export default {
  "hub": {
    "card": {
      "trigger": { "MANUAL": "Manual", "SCHEDULED": "Scheduled", "CRON": "Cron", "EVENT": "Event" },
      "run": "Run now",
      "runStarted": "Refresh started for {name}",
      "runFailed": "The refresh could not be started",
      "lastUpdated": "Last updated",
      "openEditor": "Open in the editor",
      "more": "More actions"
    },
    "preview": {
      "title": "Dataset Preview",
      "description": "Description",
      "noDescription": "No description yet. Add one in the editor's Documentation panel.",
      "columns": "Columns",
      "rows": "Rows",
      "visualizations": "Visualizations",
      "latestVersion": "Latest version",
      "totalSize": "Total size",
      "trigger": "Trigger",
      "started": "Started",
      "ended": "Ended",
      "lastRun": "Last run",
      "status": { "success": "Completed", "warning": "Completed with warnings", "failed": "Failed" }
    },
    "title": "Datasets",
    "foldersSubtitle": "Folders",
    "datasetsSubtitle": "Datasets",
    "folder_select_input_placeholder": "Please select",
    "shared_datasets": "Shared Datasets",
    "readOnly": "Read-only",
    "sharedFolderMetaOne": "Shared · {count} dataset",
    "sharedFolderMetaOther": "Shared · {count} datasets",
    "sharedFolderMetaLoading": "Shared",
    "sharedFolderCalloutDismiss": "Dismiss",
    "sharedFolderCalloutTitle": "Shared with this workspace · Read-only",
    "sharedFolderCalloutBody": "These datasets are managed in {workspace}. You can open and explore them here; changes to them are made in {workspace}.",
    "shared_by": "Shared by",
    "shared_all": "Shared Datasets"
  }
};
